import { STATUS } from "../constants";

export default function StatusBadge({status}){
  const s = STATUS[status];
  if(!s) return null;
  return <span style={{fontSize:11,padding:"2px 8px",borderRadius:4,fontWeight:600,background:s.bg,color:s.cor}}>{s.l}</span>;
}
